export enum FileManagementRoute {
  // default
  HOME = '/file-management',
  // consent file import routes
  IMPORT_ANALYSIS = '/file-management/consent/import/analysis',
  CLIENT_IMPORT_ANALYSIS = '/file-management/consent/import/analysis/:clientLevel/:clientId',
  CLIENT_IMPORT_UPLOAD = '/file-management/consent/import/analysis/:clientLevel/:clientId/upload',
  CLIENT_IMPORT_UPLOAD_SUCCESS = '/file-management/consent/import/analysis/:clientLevel/:clientId/upload/success',
  // consent file export routes
  EXPORT = '/file-management/consent/export',
  // (all) file export routes
  FILE_EXPORT = '/file-management/file-export',
  FILE_EXPORT_CONFIG_CREATE = '/file-management/file-export/:clientId/create',
  FILE_EXPORT_CONFIG_EDIT = '/file-management/file-export/:clientId/:folderName/edit',
}
